module.exports = __webpack_public_path__ + "components/MapControl/svg/Zbiornik wodny.svg?52c94c0b";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Zbiornik wodny.svg
// module id = 2054
// module chunks = 0